import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-20 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-96">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-97">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-charcoal leading-tight mb-6" data-id="element-98">
              El Protocolo Vientre Plano 40+:{' '}
              <span className="text-coral italic font-normal" data-id="element-99">
                Desinflama tu abdomen hormonal en 7 días
              </span>
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-100">
              Recupera tu cintura y cierra tus jeans favoritos sin dietas
              extremas, sin cardio agotador y sin pasar hambre.
            </p>
            <div className="flex flex-col items-center lg:items-start space-y-4" data-id="element-101">
              <CTAButton className="w-full sm:w-auto" data-id="element-102">
                ¡SÍ, QUIERO MI VIENTRE PLANO 40+ AHORA!
              </CTAButton>
              <p className="text-sm text-gray-500 font-medium" data-id="element-103">
                Acceso instantáneo · Pago único{' '}
                <span className="line-through text-gray-400" data-id="element-104">$27</span>{' '}
                <span className="text-coral font-bold" data-id="element-105">$6.39 USD</span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-none relative" data-id="element-106">
            <div className="absolute inset-0 bg-coral-light rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-107"></div>
            <img src="https://cdn.magicpatterns.com/uploads/g9G8Hf4zV8CMRpUSrDsS1T/Vientre_Plano_402B.png" alt="Protocolo Vientre Plano 40+ eBook en tablet" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-108" />
          </motion.div>
        </div>
      </div>
    </section>;
}